import { Component, Input } from '@angular/core';
import { AdminPlatformStats, AdminWalletsStats } from '../../../models/admin-overview.model';

/** "Platform" card at the top of the Overview: point-in-time counts that the
 *  range picker does not affect. Plain figures, no trends /overview returns
 *  no comparison for these, and invented ones are worse than none. */
@Component({
  selector: 'app-platform-stats-row',
  standalone: false,
  templateUrl: './platform-stats-row.html',
})
export class PlatformStatsRow {
  @Input({ required: true }) platform!: AdminPlatformStats;
  @Input({ required: true }) wallets!: AdminWalletsStats;
}
